import Images from '@assets/images';
import { Accordion, Button, Typography } from '@components/base';
import { Avatar, DocumentRow } from '@components/common';
import { DOCUMENT_GENERATION_STATUS } from '@helpers/constants';
import { AppContext } from '@helpers/hooks/AppContext';
import { ITaskTabProps } from '@helpers/types/task-tabs';
import { getFormattedDate } from '@helpers/utils';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../components/footer';
import css from './index.module.scss';
import { Link } from 'react-router-dom';

interface IPackingListCard {
  taskData: Partial<ITaskTabProps>;
}

const GeneratePackingList = (props: IPackingListCard) => {
  const navigate = useNavigate();
  const params = useParams();
  const { appDispatch } = useContext(AppContext);
  const { taskData } = props;
  const taskItem = taskData;

  /**
   * Used for for doc generation status and render UI accordingly
   */
  const docGenerationStatus = useMemo(() => {
    if (taskItem?.pre_shipment_packaging_generation_status as any) {
      return DOCUMENT_GENERATION_STATUS.find(
        (i) => i.value === taskItem?.pre_shipment_packaging_generation_status
      )?.label;
    }
    return null;
  }, [taskItem]);

  return (
    <div className={css.mainWrapper}>
      <Accordion defaultExpanded>
        <Accordion.Header className={css.accordionHeader}>
          <div className={css.header}>
            <div className={css.wrapper}>
              {!taskItem?.is_completed ? (
                <Avatar src={Images.illustrationEdit} alt="" />
              ) : (
                <Avatar src={Images.alertSuccessFaint} alt="" />
              )}

              <Link to={`/order/${taskItem?.order}`} style={{ textDecoration: 'none' }}>
                <Typography variant="h5" className={css.underlineOnHover}>
                  #{taskItem?.readable_task_id} - Generate Pre-Shipment Packing List
                </Typography>
              </Link>
            </div>
            <div className={css.pocWrapper}>
              {!taskItem?.is_completed && !docGenerationStatus && (
                <Button
                  variant="text"
                  disabled={!taskItem?.is_custom_invoice_generated}
                  onClick={() => {
                    appDispatch({
                      type: 'setPIData',
                      payload: {
                        task_id: taskItem?.task_id,
                        order_id: taskItem?.order,
                        invoiceType: 'pre_shipment'
                      }
                    });
                    navigate(
                      `/order/generate-packing-list/${
                        (params.id as string) ?? (taskItem?.order as string)
                      }`
                    );
                  }}
                  className={css.assignButton}>
                  {taskItem?.is_custom_invoice_generated
                    ? `Generate`
                    : `Can be generated after Custom Invoice`}
                </Button>
              )}
              {!taskItem?.is_completed &&
                (docGenerationStatus == 'DOC_GENERATION_PROCESSING' ||
                  docGenerationStatus == 'DOC_GENERATION_REQUESTED') && (
                  <Button variant="text" disabled className={css.assignButton}>
                    Document generation in process
                  </Button>
                )}
              {!taskItem?.is_completed && docGenerationStatus == 'DOC_GENERATION_FAILED' && (
                <Button variant="text" disabled className={css.assignButton}>
                  Document Generation Failed
                </Button>
              )}
            </div>
          </div>
        </Accordion.Header>
      </Accordion>
      <Footer
        createdDate={props.taskData.created_at as Date}
        updatedDate={props.taskData.updated_at as Date}
      />
    </div>
  );
};

export default GeneratePackingList;
